<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap v-if="currentUserRoleID<=2 || currentUserRoleID >= 3">
                <v-flex sm12 lg12>
                    <v-layout row wrap>
                        <v-flex sm12 lg12>

                            <!-- v-card  -->
                            <v-card class="mb-4">
                                <v-expansion-panel v-model="expandedModel" expand>
                                    <v-expansion-panel-content class="teal">
                                        <div slot="header" >
                                            <span class="white--text">
                                                All Chilled Water Pump Maintenance Checklist
                                                <strong class="black--text ml-2">

                                                </strong>
                                            </span>
                                        </div>
                                        <v-divider></v-divider>

                                        <v-card-text class="white">
                                             <!-- bulk edit actions  -->
                                            <v-flex xs12 v-if="selected.length>0 && showBulkSignButton">
                                                <v-layout row align-start justify-end mr-2>
                                                    <p class="text-lg-right caption grey--text">
                                                        Bulk Actions:
                                                        <v-layout row align-end justify-end mt-2>
                                                            <div class="">
                                                                <v-btn color="info" v-on:click="navigateToBulkDialogPage">
                                                                    <span class="">SBST Sign</span>
                                                                </v-btn>
                                                            </div>
                                                        </v-layout>
                                                    </p>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 sm12 md12 mt-3>
                                                <v-data-table
                                                    v-model="selected"
                                                    :headers="fvs.headers"
                                                    :items="items"
                                                    item-key="id"
                                                    hide-actions
                                                    select-all
                                                    class="elevation-1"
                                                >
                                                    <template slot="headers" slot-scope="props">
                                                        <tr>
                                                            <th>
                                                                <v-checkbox
                                                                    :input-value="props.all"
                                                                    :indeterminate="props.indeterminate"
                                                                    primary
                                                                    hide-details
                                                                    @click.stop="toggleAll"
                                                                ></v-checkbox>
                                                            </th>
                                                            <th
                                                                v-for="header in props.headers"
                                                                :key="header.text"
                                                                :class="['column sortable']"
                                                            >
                                                                {{ header.text }}
                                                            </th>
                                                        </tr>
                                                    </template>
                                                    <template
                                                        slot="items" slot-scope="props"
                                                    >
                                                         <tr :active="props.selected" @click="props.selected = !props.selected">
                                                            <td>
                                                                <v-checkbox
                                                                    :input-value="props.selected"
                                                                    primary
                                                                    hide-details
                                                                ></v-checkbox>
                                                            </td>
                                                            <td>{{ (props.index + 1)+((current_page_id-1)*per_page) }}</td>
                                                            <td class="text-xs-left"><span class="">{{ props.item.checklist_no }}</span></td>
                                                            <td class="text-xs-left"><span class="">{{ props.item.date }}</span></td>
                                                            <td class="text-xs-left"><span class="">{{ props.item.type_of_maintenance }}</span></td>
                                                            <!-- <td class="text-xs-left"><span class="">{{ getActivatedName(props.item.activated) }}</span></td> -->
                                                            <td>
                                                                <v-layout row wrap>
                                                                    <v-flex xs4 pa-2>
                                                                        <v-btn
                                                                            fab outline small color="success"
                                                                            v-on:click="openViewDialogAction(props.item)"
                                                                        >
                                                                            <v-icon>visibility</v-icon>
                                                                        </v-btn>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </td>
                                                            <td>
                                                                <v-layout row wrap>
                                                                    <v-flex xs4 pa-2>
                                                                        <v-btn
                                                                            fab outline small color="light-blue"
                                                                            v-on:click="openEditDialogAction(props.item)"
                                                                        >
                                                                            <v-icon>edit</v-icon>
                                                                        </v-btn>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </td>

                                                            <td>
                                                                <v-layout row wrap>
                                                                    <v-flex xs4 pa-2>
                                                                        <v-btn
                                                                            fab outline small color="light-blue"
                                                                            v-on:click="downloadReportNow(props.item)"
                                                                        >
                                                                            <v-icon>cloud_download</v-icon>
                                                                        </v-btn>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </td>

                                                            <td>
                                                                <v-layout row wrap>
                                                                    <v-flex xs4 pa-2>
                                                                        <v-btn
                                                                            fab outline small color="red"
                                                                            v-on:click="openDeleteDialogAction(props.item)"
                                                                        >
                                                                            <v-icon>delete</v-icon>
                                                                        </v-btn>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                                <v-flex mt-5>
                                                    <app-vue-pagination :collection.sync="collection"></app-vue-pagination>
                                                </v-flex>
                                            </v-flex>

                                            <v-layout row mt-5>
                                                <!-- fab button  -->
                                                <v-btn
                                                    color="pink" dark absolute
                                                    bottom right fab
                                                    title="Add New Franchise Category"
                                                    v-on:click="openAddDialogAction"
                                                  >
                                                    <v-icon>add</v-icon>
                                                </v-btn>
                                            </v-layout>
                                        </v-card-text>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-card>

                        </v-flex>
                    </v-layout>

                    <!-- dialog modal  -->

                    <!-- view & download dialog -->
                    <v-layout row justify-center v-if="selectedObj != null">
                        <app-vue-html2pdf
                            :show-layout="false"
                            :enable-download="true"
                            :preview-modal="false"
                            :paginate-elements-by-height="2000"
                            :filename="selectedObj.report_no"
                            :pdf-quality="3"
                            :manual-pagination="true"
                            pdf-format="a4"
                            pdf-orientation="portrait"
                            pdf-content-width="800px"
                            
                            @progress="onProgress($event)"
                            @hasStartedGeneration="hasStartedGeneration()"
                            @hasGenerated="hasGenerated($event)"
                            ref="html2Pdf"
                        >
                            <section slot="pdf-content">
                                <div class="container border-container" v-if="selectedObj != null">
                                    <div class="mt3">
                                        <h2 class="pdf-header textBlack">
                                            Condenser Water Pump Maintenance Checklist
                                        </h2>
                                    </div>    
                                    <div>
                                        <v-layout row wrap>
                                            <v-flex xs12 >
                                                <!-- submit date  -->
                                                <v-layout row wrap>
                                                    <v-flex md3 xs12>
                                                        <v-subheader class="subTitle textBlack">
                                                            <strong>Date</strong>
                                                        </v-subheader>
                                                    </v-flex>
                                                    <v-flex md9 xs12>
                                                        <v-subheader class="subTitle textBlack" >: {{ computedEditSubmitDate }} </v-subheader>
                                                    </v-flex>
                                                </v-layout>

                                                <!-- station  -->
                                                <v-layout row wrap style="margin-top: -20px">
                                                    <v-flex md3 xs12>
                                                        <v-subheader class="subTitle textBlack">
                                                            <strong>Station</strong>
                                                        </v-subheader>
                                                    </v-flex>
                                                    <v-flex md9 xs12>
                                                        <v-subheader class="subTitle textBlack" >: {{ allStations[selectedObj.station_id-1] != null ? `${allStations[selectedObj.station_id-1].station_no } - ${ allStations[selectedObj.station_id-1].station_name}` : 'N/A' }}</v-subheader>
                                                    </v-flex>
                                                </v-layout>
                                                

                                                <!-- type of maintenance  -->
                                                <v-layout row wrap style="margin-top: -20px">
                                                    <v-flex md3 xs12>
                                                        <v-subheader class="subTitle textBlack">
                                                            <strong>Type of Maintenance:</strong>
                                                        </v-subheader>
                                                    </v-flex>
                                                    <v-flex md9 xs12>
                                                        <v-subheader class="subTitle textBlack" >: {{ selectedObj.type_of_maintenance }}</v-subheader>
                                                    </v-flex>
                                                </v-layout>

                                                <!-- type of maintenance  -->
                                                <v-layout row wrap style="margin-top: -20px">
                                                    <v-flex md3 xs12>
                                                        <v-subheader class="subTitle textBlack">
                                                            <strong>Equipment ID</strong>
                                                        </v-subheader>
                                                    </v-flex>
                                                    <v-flex md9 xs12>
                                                        <v-subheader class="subTitle textBlack" >: {{ allEquipments[selectedObj.equipment_id-1] != null ? `${ allEquipments[selectedObj.equipment_id-1].equipment_type_name }` : 'N/A' }}</v-subheader>
                                                    </v-flex>
                                                </v-layout>

                                                <!-- type of maintenance  -->
                                                <v-layout row wrap >
                                                    <table class="pdf">
                                                        <thead>
                                                            <th>
                                                                <strong>No.</strong>
                                                            </th>
                                                            <th>
                                                                <strong>Task Description</strong>
                                                            </th>
                                                            <th>
                                                                <strong>Result</strong>
                                                            </th>
                                                            <th>
                                                                <strong>Remarks</strong>
                                                            </th>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td class="tableTextCenter" rowspan="1">1</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                        Check and clean strainer, if necessary	
                                                                    </span>
                                                                </td>
                                                                <td class="tableTextCenter">
                                                                    <span>{{ selectedObj.task_1 == 1 ? 'Check' : 'Not Check' }}</span>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <span>{{ selectedObj.task_1_remarks }}</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">2</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Check visually that there is no water leakage from mechanical seal	
                                                                    </span>
                                                                </td>
                                                                <td class="tableTextCenter">
                                                                    <span>{{ selectedObj.task_2 == 1 ? 'Check' : 'Not Check' }}</span>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <span>{{ selectedObj.task_2_remarks }}</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">3</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Check that coupling bush is not worn out		
                                                                    </span>
                                                                </td>
                                                                <td class="tableTextCenter">
                                                                    <span>{{ selectedObj.task_3 == 1 ? 'Check' : 'Not Check' }}</span>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <span>{{ selectedObj.task_3_remarks }}</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">4</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Check visually that there is no leakage from the mechanical seal		
                                                                    </span>
                                                                </td>
                                                                <td class="tableTextCenter">
                                                                    <span>{{ selectedObj.task_4 == 1 ? 'Check' : 'Not Check' }}</span>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <span>{{ selectedObj.task_4_remarks }}</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">5</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Open up water valves slowly and restores to its original setting		
                                                                    </span>
                                                                </td>
                                                                <td class="tableTextCenter">
                                                                    <span>{{ selectedObj.task_5 == 1 ? 'Check' : 'Not Check' }}</span>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <span>{{ selectedObj.task_5_remarks }}</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">6</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Press Emergency stop lock switch button to verify its operation			
                                                                    </span>
                                                                </td>
                                                                <td class="tableTextCenter">
                                                                    <span>{{ selectedObj.task_6 == 1 ? 'Check' : 'Not Check' }}</span>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <span>{{ selectedObj.task_6_remarks }}</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">7</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Lubricate electric motor as applicable		
                                                                    </span>
                                                                </td>
                                                                <td class="tableTextCenter">
                                                                    <span>{{ selectedObj.task_7 == 1 ? 'Check' : 'Not Check' }}</span>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <span>{{ selectedObj.task_7_remarks }}</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">8</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Check differential pressure (Suction and Discharge pressure) of the pump is as per original setting		
                                                                    </span>
                                                                </td>
                                                                <td class="tableTextCenter">
                                                                    <span>{{ selectedObj.task_8 == 1 ? 'Check' : 'Not Check' }}</span>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <span>{{ selectedObj.task_8_remarks }}</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">9</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Inspect motor terminal box wiring for loose connection			
                                                                    </span>
                                                                </td>
                                                                <td class="tableTextCenter">
                                                                    <span>{{ selectedObj.task_9 == 1 ? 'Check' : 'Not Check' }}</span>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <span>{{ selectedObj.task_9_remarks }}</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">10</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Dismantle, inspect and clean snubber assembly of the pressure gauge				
                                                                    </span>
                                                                </td>
                                                                <td class="tableTextCenter">
                                                                    <span>{{ selectedObj.task_10 == 1 ? 'Check' : 'Not Check' }}</span>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <span>{{ selectedObj.task_10_remarks }}</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">11</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       CHECK MOTOR RUNNING IS WITH “FULL LOAD”	
                                                                    </span>
                                                                </td>
                                                                <td class="tableTextCenter">
                                                                    <span>{{ selectedObj.task_11 == 1 ? 'Check' : 'Not Check' }}</span>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <span>{{ selectedObj.task_11_remarks }}</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">12</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Inspect equipment and mounting for sign of corrosions. Remove rust spot and touch-up surface with anti-corrosion / cold galvanising compound whichever applicable	
                                                                    </span>
                                                                </td>
                                                                <td class="tableTextCenter">
                                                                    <span>{{ selectedObj.task_12 == 1 ? 'Check' : 'Not Check' }}</span>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <span>{{ selectedObj.task_12_remarks }}</span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <table class="pdf">
                                                        <thead>
                                                            <th>
                                                                <strong>Additional Remarks</strong>
                                                            </th>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td rowspan="5">
                                                                    <div style="min-height: 65px;">
                                                                        <span>
                                                                            {{ selectedObj.additional_remarks }}
                                                                        </span>
                                                                    </div>  
                                                                    
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <table class="pdf">
                                                        <thead>
                                                            <th>
                                                                <strong>Maintenanced By: {{ selectedObj.maintained_by_name }}</strong>
                                                            </th>
                                                            <th>
                                                                <strong>SBST Signed Off: {{ selectedObj.signed_by_sbst_name }}</strong>
                                                            </th>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <div style="min-height: 120px;">
                                                                        <v-img
                                                                            class="img.img-upload"
                                                                            :src="selectedObj.maintained_by_signature"
                                                                            width="120"
                                                                            height="120"
                                                                        >
                                                                        </v-img>
                                                                    </div>
                                                                    
                                                                </td>
                                                                <td>
                                                                    <div style="min-height: 120px;">
                                                                        <v-img
                                                                            class="img.img-upload"
                                                                            :src="selectedObj.signed_by_sbst_signature"
                                                                            width="120"
                                                                            height="120"
                                                                        >
                                                                        </v-img>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>  
                                                </v-layout>
                                             </v-flex>
                                        </v-layout>
                                    </div>
                                    <!-- <div style="height: 50px;"></div>   -->
                                </div>
                            </section>
                        </app-vue-html2pdf>
                    </v-layout>

                    <!-- view dialog -->
                    <v-layout row justify-center>
                        <v-dialog v-model="openViewDialog"
                            fullscreen hide-overlay
                            transition="dialog-bottom-transition">

                            <v-card>
                                <v-toolbar dark color="teal" fixed>
                                    <v-btn icon dark
                                        @click="openViewDialog = false">
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>
                                        <span class="white--text title">
                                           Condenser Water Pump Maintenance Checklist
                                        </span>
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <v-card-text>
                                    <v-card-text class="white">
                                        <v-flex xs12 sm12 md12 style="margin-top: 5%; padding-left: 10px; padding-right: 10px;">

                                            <v-layout row wrap>
                                                <v-flex xs12 md5>
                                                    <!-- submit date  -->
                                                    <v-layout row wrap>
                                                        <v-flex md3 xs12>
                                                            <v-subheader class="subTitle">Date</v-subheader>
                                                        </v-flex>
                                                        <v-flex md9 xs12>
                                                            <v-menu
                                                                v-model="editSubmitDateMenu"
                                                                :close-on-content-click="false"
                                                                full-width max-width="290"
                                                            >
                                                                <v-text-field
                                                                    slot="activator"
                                                                    :value="computedEditSubmitDate"
                                                                    label="Date"
                                                                    prepend-icon="calendar_today"
                                                                    readonly
                                                                    disabled
                                                                >
                                                                </v-text-field>
                                                            </v-menu>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs12 md1></v-flex>

                                                <v-flex xs12 md5>
                                                    <!-- Station -->
                                                    <v-layout row wrap>
                                                        <v-flex md4 xs12>
                                                            <v-subheader class="subTitle">Station</v-subheader>
                                                        </v-flex>
                                                        <v-flex md8 xs12>
                                                            <v-select
                                                                disabled
                                                                :items="allStations"
                                                                item-value="id"
                                                                v-model="selectedObj.station_id"
                                                                item-text="station_name"
                                                                single-line
                                                                label="Stations"
                                                                persistent-hint
                                                                hint="Select Station"
                                                                v-on:change="selectedStationID"
                                                            >
                                                                <template slot="selection" slot-scope="data">
                                                                        {{ data.item.station_no }} - {{ data.item.station_name }}
                                                                </template>
                                                                <template slot="item" slot-scope="data">
                                                                    {{ data.item.station_no }} - {{ data.item.station_name }}
                                                                </template>
                                                            </v-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>    
                                            </v-layout>

                                            <v-layout row wrap md5>
                                                <v-flex xs12 md5>
                                                    <!-- equipment id  -->
                                                    <v-layout row wrap>
                                                        <v-flex md3 xs12>
                                                            <v-subheader class="subTitle">Equipment ID</v-subheader>
                                                        </v-flex>
                                                        <v-flex md9 xs12>
                                                            <v-select
                                                                disabled
                                                                :items="allEquipments"
                                                                item-value="id"
                                                                v-model="selectedObj.equipment_id"
                                                                item-text="equipment_type_name"
                                                                single-line
                                                                label="Equipment"
                                                                persistent-hint
                                                                hint="Select Equipment"
                                                                v-on:change="selectedNewEquipmentID"
                                                            >
                                                                <template slot="selection" slot-scope="data">
                                                                        {{ data.item.equipment_type_name }}
                                                                </template>
                                                                <template slot="item" slot-scope="data">
                                                                    {{ data.item.equipment_type_name }}
                                                                </template>
                                                            </v-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs12 md1></v-flex>

                                                <v-flex xs12 md5>
                                                    <!-- type of maintenance -->
                                                    <v-layout row wrap>
                                                        <v-flex md4 xs12>
                                                            <v-subheader class="subTitle">Type of Maintenance</v-subheader>
                                                        </v-flex>
                                                        <v-flex md8 xs12>
                                                            <v-select
                                                                disabled
                                                                :items="type_of_maintenance"
                                                                item-value="name"
                                                                v-model="selectedObj.type_of_maintenance"
                                                                item-text="name"
                                                                single-line
                                                                label="Type of Maintenance"
                                                                persistent-hint
                                                                hint="Select type of maintenance"
                                                                v-on:change="selectedNewTypeOfMaintenance"
                                                            >
                                                                <template slot="selection" slot-scope="data">
                                                                    {{ data.item.name }}
                                                                </template>
                                                                <template slot="item" slot-scope="data">
                                                                    {{ data.item.name }}
                                                                </template>
                                                            </v-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>    
                                            </v-layout>

                                            <v-layout row wrap style="margin-top: 80px;margin-bottom: 80px;">
                                                <v-flex xs12>
                                                    <hr style="border: 1px solid green;" />
                                                </v-flex>
                                            </v-layout>

                                            <h3 v-if="selectedObj.type_of_maintenance != null" style="margin-bottom: 10px;"><span style="color: red;">*</span>{{ selectedObj.type_of_maintenance }}</h3>

                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <table class="myFormTable">
                                                        <thead>
                                                            <tr>
                                                                <th>No.</th>
                                                                <th>Task Descriptions</th>
                                                                <th>Options</th>
                                                                <th>Remarks</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td rowspan="1">1</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                        Check and clean strainer, if necessary	
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group disabled v-model="selectedObj.task_1" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        disabled
                                                                        v-model="selectedObj.task_1_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">2</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Check visually that there is no water leakage from mechanical seal	
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group disabled v-model="selectedObj.task_2" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        disabled
                                                                        v-model="selectedObj.task_2_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">3</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Check that coupling bush is not worn out		
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group disabled v-model="selectedObj.task_3" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        disabled
                                                                        v-model="selectedObj.task_3_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">4</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Check visually that there is no leakage from the mechanical seal		
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group disabled v-model="selectedObj.task_4" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        disabled
                                                                        v-model="selectedObj.task_4_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">5</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Open up water valves slowly and restores to its original setting		
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group disabled v-model="selectedObj.task_5" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        disabled
                                                                        v-model="selectedObj.task_5_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">6</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Press Emergency stop lock switch button to verify its operation			
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group disabled v-model="selectedObj.task_6" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        disabled
                                                                        v-model="selectedObj.task_6_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">7</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Lubricate electric motor as applicable		
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group disabled v-model="selectedObj.task_7" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        disabled
                                                                        v-model="selectedObj.task_7_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">8</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Check differential pressure (Suction and Discharge pressure) of the pump is as per original setting		
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group disabled v-model="selectedObj.task_8" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        disabled
                                                                        v-model="selectedObj.task_8_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">9</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Inspect motor terminal box wiring for loose connection			
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group disabled v-model="selectedObj.task_9" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        disabled
                                                                        v-model="selectedObj.task_9_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">10</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Dismantle, inspect and clean snubber assembly of the pressure gauge				
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group disabled v-model="selectedObj.task_10" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        disabled
                                                                        v-model="selectedObj.task_10_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">11</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       CHECK MOTOR RUNNING IS WITH “FULL LOAD”	
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group disabled v-model="selectedObj.task_11" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        disabled
                                                                        v-model="selectedObj.task_11_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">12</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Inspect equipment and mounting for sign of corrosions. Remove rust spot and touch-up surface with anti-corrosion / cold galvanising compound whichever applicable	
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group disabled v-model="selectedObj.task_12" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        disabled
                                                                        v-model="selectedObj.task_12_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                        </tbody> 
                                                    </table>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap style="margin-top: 80px;margin-bottom: 80px;">
                                                <v-flex xs12>
                                                    <hr style="border: 1px solid green;" />
                                                </v-flex>
                                            </v-layout>

                                            <!-- Additional Remarks -->
                                            <v-layout row wrap mt-3>
                                                <v-flex xs12 md12 lg12>
                                                    <v-textarea
                                                        box
                                                        disabled
                                                        type="text"
                                                        label="Additional Remarks"
                                                        v-model="selectedObj.additional_remarks"
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>
                                           
                                           <v-layout row wrap mt-3>
                                               <v-flex xs12 md5>
                                                    <!-- maintained_by_name -->
                                                    <v-layout row wrap>
                                                        <v-flex xs12 md12 lg12>
                                                            <v-text-field
                                                                type="text"
                                                                disabled
                                                                label="Maintained By Name"
                                                                v-model="selectedObj.maintained_by_name">
                                                            </v-text-field>
                                                        </v-flex>
                                                    </v-layout>

                                                    <v-layout row wrap>
                                                        <v-img
                                                            class="img.img-upload"
                                                            :src="getFeatureImages(selectedObj.maintained_by_signature)"
                                                            width="150"
                                                            height="150"
                                                        >
                                                        </v-img>
                                                    </v-layout>
                                               </v-flex>

                                               <v-flex xs12 md1></v-flex>

                                               <v-flex xs12 md5>
                                                   <!-- signed_by_sbst_name -->
                                                    <v-layout row wrap>
                                                        <v-flex xs12 md12 lg12>
                                                            <v-text-field
                                                                type="text"
                                                                disabled
                                                                label="SBST Signed Off"
                                                                v-model="selectedObj.signed_by_sbst_name">
                                                            </v-text-field>
                                                        </v-flex>
                                                    </v-layout>

                                                    <v-layout row wrap>
                                                        <v-flex xs12 md12 lg12 v-if="openSignPad2">
                                                            <v-img
                                                                class="img.img-upload"
                                                                :src="getFeatureImages(selectedObj.signed_by_sbst_signature)"
                                                                width="150"
                                                                height="150"
                                                            >
                                                            </v-img>
                                                        </v-flex>
                                                    </v-layout>
                                               </v-flex>
                                           </v-layout>
                                        </v-flex>
                                    </v-card-text>
                                </v-card-text>
                          </v-card>
                        </v-dialog>
                    </v-layout>

                    <!-- create dialog -->
                    <v-layout row justify-center>
                        <v-dialog v-model="openAddDialog"
                            fullscreen hide-overlay
                            transition="dialog-bottom-transition">

                            <v-card>
                                <v-toolbar dark color="teal" fixed>
                                    <v-btn icon dark
                                        @click="openAddDialog = false">
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>
                                        <span class="white--text title">
                                            Add New Maintenance Checklist
                                        </span>
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                            dark flat @click="addResourceAction">
                                            Add
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <v-card-text>
                                    <v-card-text class="white">
                                        <v-flex xs12 sm12 md12 style="margin-top: 5%; padding-left: 10px; padding-right: 10px;">

                                            <v-layout row wrap>
                                                <v-flex xs12 md5>
                                                    <!-- submit date  -->
                                                    <v-layout row wrap>
                                                        <v-flex md3 xs12>
                                                            <v-subheader class="subTitle">Date</v-subheader>
                                                        </v-flex>
                                                        <v-flex md9 xs12>
                                                            <v-menu
                                                                v-model="newSubmitDateMenu"
                                                                :close-on-content-click="false"
                                                                full-width max-width="290"
                                                            >
                                                                <v-text-field
                                                                    slot="activator"
                                                                    :value="computedNewSubmitDate"
                                                                    clearable
                                                                    label="Date"
                                                                    prepend-icon="calendar_today"
                                                                    readonly
                                                                >
                                                                </v-text-field>
                                                                <v-date-picker
                                                                    v-model="newSelectedObj.date"
                                                                    @change="newSubmitDateMenu = false"
                                                                    >
                                                                </v-date-picker>
                                                            </v-menu>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs12 md1></v-flex>

                                                <v-flex xs12 md5>
                                                    <!-- Station -->
                                                    <v-layout row wrap>
                                                        <v-flex md4 xs12>
                                                            <v-subheader class="subTitle">Station</v-subheader>
                                                        </v-flex>
                                                        <v-flex md8 xs12>
                                                            <v-select
                                                                :items="allStations"
                                                                item-value="id"
                                                                v-model="newSelectedObj.station_id"
                                                                item-text="station_name"
                                                                single-line
                                                                label="Stations"
                                                                persistent-hint
                                                                hint="Select Station"
                                                                v-on:change="selectedNewStationID"
                                                            >
                                                                <template slot="selection" slot-scope="data">
                                                                        {{ data.item.station_no }} - {{ data.item.station_name }}
                                                                </template>
                                                                <template slot="item" slot-scope="data">
                                                                    {{ data.item.station_no }} - {{ data.item.station_name }}
                                                                </template>
                                                            </v-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>    
                                            </v-layout>

                                            <v-layout row wrap md5>
                                                <v-flex xs12 md5>
                                                    <!-- equipment id  -->
                                                    <v-layout row wrap>
                                                        <v-flex md3 xs12>
                                                            <v-subheader class="subTitle">Equipment ID</v-subheader>
                                                        </v-flex>
                                                        <v-flex md9 xs12>
                                                            <v-select
                                                                :items="allEquipments"
                                                                item-value="id"
                                                                v-model="newSelectedObj.equipment_id"
                                                                item-text="equipment_type_name"
                                                                single-line
                                                                label="Equipment"
                                                                persistent-hint
                                                                hint="Select Equipment"
                                                                v-on:change="selectedNewEquipmentID"
                                                            >
                                                                <template slot="selection" slot-scope="data">
                                                                        {{ data.item.equipment_type_name }}
                                                                </template>
                                                                <template slot="item" slot-scope="data">
                                                                    {{ data.item.equipment_type_name }}
                                                                </template>
                                                            </v-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs12 md1></v-flex>

                                                <v-flex xs12 md5>
                                                    <!-- type of maintenance -->
                                                    <v-layout row wrap>
                                                        <v-flex md4 xs12>
                                                            <v-subheader class="subTitle">Type of Maintenance</v-subheader>
                                                        </v-flex>
                                                        <v-flex md8 xs12>
                                                            <v-select
                                                                :items="type_of_maintenance"
                                                                item-value="name"
                                                                v-model="newSelectedObj.type_of_maintenance"
                                                                item-text="name"
                                                                single-line
                                                                label="Type of Maintenance"
                                                                persistent-hint
                                                                hint="Select type of maintenance"
                                                                v-on:change="selectedNewTypeOfMaintenance"
                                                            >
                                                                <template slot="selection" slot-scope="data">
                                                                    {{ data.item.name }}
                                                                </template>
                                                                <template slot="item" slot-scope="data">
                                                                    {{ data.item.name }}
                                                                </template>
                                                            </v-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>    
                                            </v-layout>

                                            <v-layout row wrap style="margin-top: 80px;margin-bottom: 80px;">
                                                <v-flex xs12>
                                                    <hr style="border: 1px solid green;" />
                                                </v-flex>
                                            </v-layout>

                                            <h3 v-if="newSelectedObj.type_of_maintenance != null" style="margin-bottom: 10px;"><span style="color: red;">*</span>{{ newSelectedObj.type_of_maintenance }}</h3>

                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <table class="myFormTable">
                                                        <thead>
                                                            <tr>
                                                                <th>No.</th>
                                                                <th>Task Descriptions</th>
                                                                <th>Options</th>
                                                                <th>Remarks</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td rowspan="1">1</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                        Check and clean strainer, if necessary	
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="newSelectedObj.task_1" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="newSelectedObj.task_1_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">2</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Check visually that there is no water leakage from mechanical seal	
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="newSelectedObj.task_2" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="newSelectedObj.task_2_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">3</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Check that coupling bush is not worn out		
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="newSelectedObj.task_3" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="newSelectedObj.task_3_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">4</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Check visually that there is no leakage from the mechanical seal		
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="newSelectedObj.task_4" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="newSelectedObj.task_4_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">5</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Open up water valves slowly and restores to its original setting		
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="newSelectedObj.task_5" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="newSelectedObj.task_5_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">6</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Press Emergency stop lock switch button to verify its operation			
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="newSelectedObj.task_6" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="newSelectedObj.task_6_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">7</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Lubricate electric motor as applicable		
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="newSelectedObj.task_7" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="newSelectedObj.task_7_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">8</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Check differential pressure (Suction and Discharge pressure) of the pump is as per original setting		
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="newSelectedObj.task_8" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="newSelectedObj.task_8_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">9</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Inspect motor terminal box wiring for loose connection			
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="newSelectedObj.task_9" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="newSelectedObj.task_9_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">10</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Dismantle, inspect and clean snubber assembly of the pressure gauge				
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="newSelectedObj.task_10" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="newSelectedObj.task_10_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">11</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       CHECK MOTOR RUNNING IS WITH “FULL LOAD”	
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="newSelectedObj.task_11" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="newSelectedObj.task_11_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">12</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Inspect equipment and mounting for sign of corrosions. Remove rust spot and touch-up surface with anti-corrosion / cold galvanising compound whichever applicable	
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="newSelectedObj.task_12" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="newSelectedObj.task_12_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                        </tbody> 
                                                    </table>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap style="margin-top: 80px;margin-bottom: 80px;">
                                                <v-flex xs12>
                                                    <hr style="border: 1px solid green;" />
                                                </v-flex>
                                            </v-layout>

                                            <!-- Additional Remarks -->
                                            <v-layout row wrap mt-3>
                                                <v-flex xs12 md12 lg12>
                                                    <v-textarea
                                                        box
                                                        type="text"
                                                        label="Additional Remarks"
                                                        v-model="newSelectedObj.additional_remarks"
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>
                                           
                                           <v-layout row wrap mt-3>
                                               <v-flex xs12 md5>
                                                    <!-- maintained_by_name -->
                                                    <v-layout row wrap>
                                                        <v-flex xs12 md12 lg12>
                                                            <v-text-field
                                                                type="text"
                                                                label="Maintained By Name"
                                                                v-model="newSelectedObj.maintained_by_name">
                                                            </v-text-field>
                                                        </v-flex>
                                                    </v-layout>

                                                     <v-layout row wrap>
                                                        <v-flex xs12 md12 lg12 v-if="openNewSignPad1">
                                                            <VueSignaturePad
                                                                class="signature_box"
                                                                id="signature"
                                                                width="100%"
                                                                height="500px"
                                                                ref="newSignaturePad1"
                                                            />
                                                        </v-flex>
                                                        <v-layout row wrap v-if="openNewSignPad1">
                                                            <v-flex xs6 md6 lg6 >
                                                                <v-btn block v-on:click="newSaveSign1" class="primary">
                                                                    <span>Save</span>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex xs6 md6 lg6 v-if="openNewSignPad1">
                                                                <v-btn block v-on:click="newUndoSign1">
                                                                    <span>Undo</span>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-layout>

                                                        <v-flex xs12 md12 lg12 v-if="!openNewSignPad1">
                                                            <v-btn block v-on:click="openNewSign1Action" class="primary">
                                                                <span>Sign Now</span>
                                                            </v-btn>
                                                        </v-flex>
                                                    </v-layout>
                                               </v-flex>

                                               <v-flex xs12 md1></v-flex>

                                               <v-flex xs12 md5>
                                                   <!-- signed_by_sbst_name -->
                                                    <v-layout row wrap>
                                                        <v-flex xs12 md12 lg12>
                                                            <v-text-field
                                                                type="text"
                                                                label="SBST Signed Off"
                                                                v-model="newSelectedObj.signed_by_sbst_name">
                                                            </v-text-field>
                                                        </v-flex>
                                                    </v-layout>

                                                    <v-layout row wrap>
                                                        <v-flex xs12 md12 lg12 v-if="openNewSignPad2">
                                                            <VueSignaturePad
                                                                class="signature_box"
                                                                id="signature"
                                                                width="100%"
                                                                height="500px"
                                                                ref="newSignaturePad2"
                                                            />
                                                        </v-flex>
                                                        <v-layout row wrap v-if="openNewSignPad2">
                                                            <v-flex xs6 md6 lg6 >
                                                                <v-btn block v-on:click="newSaveSign2" class="primary">
                                                                    <span>Save</span>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex xs6 md6 lg6 v-if="openNewSignPad2">
                                                                <v-btn block v-on:click="newUndoSign2">
                                                                    <span>Undo</span>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-layout>

                                                        <v-flex xs12 md12 lg12 v-if="!openNewSignPad2">
                                                            <v-btn block v-on:click="openNewSign2Action" class="primary">
                                                                <span>Sign Now</span>
                                                            </v-btn>
                                                        </v-flex>
                                                    </v-layout>
                                               </v-flex>
                                           </v-layout>
                                        </v-flex>
                                    </v-card-text>
                                </v-card-text>
                          </v-card>
                        </v-dialog>
                    </v-layout>

                    <!-- edit dialog -->
                    <v-layout row justify-center>
                        <v-dialog v-model="openEditDialog"
                            fullscreen hide-overlay
                            transition="dialog-bottom-transition">

                            <v-card>
                                <v-toolbar dark color="teal" fixed>
                                    <v-btn icon dark
                                        @click="openEditDialog = false">
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>
                                        <span class="white--text title">
                                            Edit Under Platform Exhaust Fan Maintenance Checklist
                                        </span>
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                            dark flat @click="editResourceAction">
                                            Update &amp; Save
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <v-card-text>
                                    <v-card-text class="white">
                                        <v-flex xs12 sm12 md12 style="margin-top: 5%; padding-left: 10px; padding-right: 10px;">

                                            <v-layout row wrap>
                                                <v-flex xs12 md5>
                                                    <!-- submit date  -->
                                                    <v-layout row wrap>
                                                        <v-flex md3 xs12>
                                                            <v-subheader class="subTitle">Date</v-subheader>
                                                        </v-flex>
                                                        <v-flex md9 xs12>
                                                            <v-menu
                                                                v-model="editSubmitDateMenu"
                                                                :close-on-content-click="false"
                                                                full-width max-width="290"
                                                            >
                                                                <v-text-field
                                                                    slot="activator"
                                                                    :value="computedEditSubmitDate"
                                                                    clearable
                                                                    label="Date"
                                                                    prepend-icon="calendar_today"
                                                                    readonly
                                                                >
                                                                </v-text-field>
                                                                <v-date-picker
                                                                    v-model="selectedObj.date"
                                                                    @change="editSubmitDateMenu = false"
                                                                    >
                                                                </v-date-picker>
                                                            </v-menu>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs12 md1></v-flex>

                                                <v-flex xs12 md5>
                                                    <!-- Station -->
                                                    <v-layout row wrap>
                                                        <v-flex md4 xs12>
                                                            <v-subheader class="subTitle">Station</v-subheader>
                                                        </v-flex>
                                                        <v-flex md8 xs12>
                                                            <v-select
                                                                :items="allStations"
                                                                item-value="id"
                                                                v-model="selectedObj.station_id"
                                                                item-text="station_name"
                                                                single-line
                                                                label="Stations"
                                                                persistent-hint
                                                                hint="Select Station"
                                                                v-on:change="selectedStationID"
                                                            >
                                                                <template slot="selection" slot-scope="data">
                                                                        {{ data.item.station_no }} - {{ data.item.station_name }}
                                                                </template>
                                                                <template slot="item" slot-scope="data">
                                                                    {{ data.item.station_no }} - {{ data.item.station_name }}
                                                                </template>
                                                            </v-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>    
                                            </v-layout>

                                            <v-layout row wrap md5>
                                                <v-flex xs12 md5>
                                                    <!-- equipment id  -->
                                                    <v-layout row wrap>
                                                        <v-flex md3 xs12>
                                                            <v-subheader class="subTitle">Equipment ID</v-subheader>
                                                        </v-flex>
                                                        <v-flex md9 xs12>
                                                            <v-select
                                                                :items="allEquipments"
                                                                item-value="id"
                                                                v-model="selectedObj.equipment_id"
                                                                item-text="equipment_type_name"
                                                                single-line
                                                                label="Equipment"
                                                                persistent-hint
                                                                hint="Select Equipment"
                                                                v-on:change="selectedNewEquipmentID"
                                                            >
                                                                <template slot="selection" slot-scope="data">
                                                                        {{ data.item.equipment_type_name }}
                                                                </template>
                                                                <template slot="item" slot-scope="data">
                                                                    {{ data.item.equipment_type_name }}
                                                                </template>
                                                            </v-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs12 md1></v-flex>

                                                <v-flex xs12 md5>
                                                    <!-- type of maintenance -->
                                                    <v-layout row wrap>
                                                        <v-flex md4 xs12>
                                                            <v-subheader class="subTitle">Type of Maintenance</v-subheader>
                                                        </v-flex>
                                                        <v-flex md8 xs12>
                                                            <v-select
                                                                :items="type_of_maintenance"
                                                                item-value="name"
                                                                v-model="selectedObj.type_of_maintenance"
                                                                item-text="name"
                                                                single-line
                                                                label="Type of Maintenance"
                                                                persistent-hint
                                                                hint="Select type of maintenance"
                                                                v-on:change="selectedNewTypeOfMaintenance"
                                                            >
                                                                <template slot="selection" slot-scope="data">
                                                                    {{ data.item.name }}
                                                                </template>
                                                                <template slot="item" slot-scope="data">
                                                                    {{ data.item.name }}
                                                                </template>
                                                            </v-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>    
                                            </v-layout>

                                            <v-layout row wrap style="margin-top: 80px;margin-bottom: 80px;">
                                                <v-flex xs12>
                                                    <hr style="border: 1px solid green;" />
                                                </v-flex>
                                            </v-layout>

                                            <h3 v-if="selectedObj.type_of_maintenance != null" style="margin-bottom: 10px;"><span style="color: red;">*</span>{{ selectedObj.type_of_maintenance }}</h3>

                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <table class="myFormTable">
                                                        <thead>
                                                            <tr>
                                                                <th>No.</th>
                                                                <th>Task Descriptions</th>
                                                                <th>Options</th>
                                                                <th>Remarks</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td rowspan="1">1</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                        Check and clean strainer, if necessary	
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="selectedObj.task_1" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="selectedObj.task_1_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">2</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Check visually that there is no water leakage from mechanical seal	
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="selectedObj.task_2" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="selectedObj.task_2_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">3</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Check that coupling bush is not worn out		
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="selectedObj.task_3" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="selectedObj.task_3_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">4</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Check visually that there is no leakage from the mechanical seal		
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="selectedObj.task_4" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="selectedObj.task_4_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">5</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Open up water valves slowly and restores to its original setting		
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="selectedObj.task_5" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="selectedObj.task_5_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">6</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Press Emergency stop lock switch button to verify its operation			
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="selectedObj.task_6" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="selectedObj.task_6_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">7</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Lubricate electric motor as applicable		
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="selectedObj.task_7" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="selectedObj.task_7_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">8</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Check differential pressure (Suction and Discharge pressure) of the pump is as per original setting		
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="selectedObj.task_8" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="selectedObj.task_8_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">9</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Inspect motor terminal box wiring for loose connection			
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="selectedObj.task_9" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="selectedObj.task_9_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">10</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Dismantle, inspect and clean snubber assembly of the pressure gauge				
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="selectedObj.task_10" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="selectedObj.task_10_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">11</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       CHECK MOTOR RUNNING IS WITH “FULL LOAD”	
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="selectedObj.task_11" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="selectedObj.task_11_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td rowspan="1">12</td>
                                                                <td colspan="1">
                                                                    <span>
                                                                       Inspect equipment and mounting for sign of corrosions. Remove rust spot and touch-up surface with anti-corrosion / cold galvanising compound whichever applicable	
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <v-radio-group  v-model="selectedObj.task_12" >
                                                                        <v-radio
                                                                            :label="`Check`"
                                                                            :value="'true'"
                                                                        >    
                                                                        </v-radio>
                                                                        <v-radio
                                                                            :label="`Not Check`"
                                                                            :value="'false'"
                                                                        >    
                                                                        </v-radio>
                                                                        
                                                                    </v-radio-group>
                                                                </td>
                                                                <td rowspan="1">
                                                                    <v-textarea
                                                                        type="text"
                                                                        rows="3"
                                                                        
                                                                        v-model="selectedObj.task_12_remarks"
                                                                    ></v-textarea>
                                                                </td>
                                                            </tr>
                                                        </tbody> 
                                                    </table>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap style="margin-top: 80px;margin-bottom: 80px;">
                                                <v-flex xs12>
                                                    <hr style="border: 1px solid green;" />
                                                </v-flex>
                                            </v-layout>

                                            <!-- Additional Remarks -->
                                            <v-layout row wrap mt-3>
                                                <v-flex xs12 md12 lg12>
                                                    <v-textarea
                                                        box
                                                        type="text"
                                                        label="Additional Remarks"
                                                        v-model="selectedObj.additional_remarks"
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>
                                           
                                           <v-layout row wrap mt-3>
                                               <v-flex xs12 md5>
                                                    <!-- maintained_by_name -->
                                                    <v-layout row wrap>
                                                        <v-flex xs12 md12 lg12>
                                                            <v-text-field
                                                                type="text"
                                                                label="Maintained By Name"
                                                                v-model="selectedObj.maintained_by_name">
                                                            </v-text-field>
                                                        </v-flex>
                                                    </v-layout>

                                                     <v-layout row wrap>
                                                        <v-flex xs12 md12 lg12 v-if="openSignPad1">
                                                            <VueSignaturePad
                                                                class="signature_box"
                                                                id="signature"
                                                                width="100%"
                                                                height="500px"
                                                                ref="signaturePad1"
                                                            />
                                                        </v-flex>
                                                        <v-layout row wrap v-if="openSignPad1">
                                                            <v-flex xs6 md6 lg6 >
                                                                <v-btn block v-on:click="saveSign1" class="primary">
                                                                    <span>Save</span>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex xs6 md6 lg6 v-if="openSignPad1">
                                                                <v-btn block v-on:click="undoSign1">
                                                                    <span>Undo</span>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-layout>

                                                        <v-flex xs12 md12 lg12 v-if="!openSignPad1">
                                                            <v-btn block v-on:click="openSign1Action" class="primary">
                                                                <span>Sign Now</span>
                                                            </v-btn>
                                                        </v-flex>
                                                    </v-layout>
                                               </v-flex>

                                               <v-flex xs12 md1></v-flex>

                                               <v-flex xs12 md5>
                                                   <!-- signed_by_sbst_name -->
                                                    <v-layout row wrap>
                                                        <v-flex xs12 md12 lg12>
                                                            <v-text-field
                                                                type="text"
                                                                label="SBST Signed Off"
                                                                v-model="selectedObj.signed_by_sbst_name">
                                                            </v-text-field>
                                                        </v-flex>
                                                    </v-layout>

                                                    <v-layout row wrap>
                                                        <v-flex xs12 md12 lg12 v-if="openSignPad2">
                                                            <VueSignaturePad
                                                                class="signature_box"
                                                                id="signature"
                                                                width="100%"
                                                                height="500px"
                                                                ref="signaturePad2"
                                                            />
                                                        </v-flex>
                                                        <v-layout row wrap v-if="openSignPad2">
                                                            <v-flex xs6 md6 lg6 >
                                                                <v-btn block v-on:click="saveSign2" class="primary">
                                                                    <span>Save</span>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex xs6 md6 lg6 v-if="openSignPad2">
                                                                <v-btn block v-on:click="undoSign2">
                                                                    <span>Undo</span>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-layout>

                                                        <v-flex xs12 md12 lg12 v-if="!openSignPad2">
                                                            <v-btn block v-on:click="openSign2Action" class="primary">
                                                                <span>Sign Now</span>
                                                            </v-btn>
                                                        </v-flex>
                                                    </v-layout>
                                               </v-flex>
                                           </v-layout>
                                        </v-flex>
                                    </v-card-text>
                                </v-card-text>
                          </v-card>
                        </v-dialog>
                    </v-layout>

                    <!-- delete dialog  -->
                    <v-layout row justify-center>
                        <v-dialog v-model="openDeleteDialog" persistent max-width="550">

                            <v-card>
                                <v-card-title class="title red white--text">Confirm Delete Report - {{ selectedObj.checklist_no }} ?</v-card-title>
                                <v-card-text>
                                    Please make sure you know what you are doing as this action is undone.
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="grey darken-1" flat @click="openDeleteDialog = false">Cancel</v-btn>
                                    <v-btn color="red darken-1" flat @click="deleteResourceAction(selectedObj.id)">Delete</v-btn>
                                </v-card-actions>
                            </v-card>
                       </v-dialog>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import moment from 'moment'
    import {
        // eslint-disable-next-line
        ACTION_STATION_GET_ALL_STATIONS,
        // eslint-disable-next-line
        GETTERS_STATION_GET_ALL_STATIONS,
    } from '../../../../../../../../utils/constants/modules/Stations/AllStationModules';
    import {
        // eslint-disable-next-line
        ACTION_STATION_GET_ALL_EQUIPMENT_TYPES,
        // eslint-disable-next-line
        GETTERS_STATION_GET_ALL_EQUIPMENT_TYPES,
    } from '../../../../../../../../utils/constants/modules/Stations/AllStationModules';
    import {
        // eslint-disable-next-line
        ACTION_CK_PM_CWPMC_GET_ALL_CWPMCS,
        // eslint-disable-next-line
        GETTERS_CK_PM_CWPMC_GET_ALL_CWPMCS,
        // eslint-disable-next-line
        ACTION_CK_PM_CWPMC_ADD_NEW_CWPMC,
        // eslint-disable-next-line
        ACTION_CK_PM_CWPMC_UPDATE_CWPMC,
        // eslint-disable-next-line
        ACTION_CK_PM_CWPMC_DELETE_CWPMC,
    } from '../../../../../../../../utils/constants/modules/CheckLists/AllCheckListsModules'

    import {
        GETTERS_USER_GROUPS_GET_AUTH_USER
    } from '../../../../../../../../utils/constants/modules/UserGroups/Users/UserModules';

    import { PaginationCollections } from '../../../../../../../../utils/mixins';

    import {
        ACTION_SET_LOADING_A
    } from '../../../../../../../../utils/constants/modules/Status/LoadingStatus/LoadingStatusModules';

    import VuePagination from '../../../../../../../../components/paginations/VuePagination.vue';
    import VueHtml2pdf from 'vue-html2pdf'
    
    export default {
        mixins: [
            PaginationCollections
        ],
        props:{
        },
        created: function () {

            let userRoleID = window.localStorage.getItem('current_user_role');

            this.currentUserRoleID = userRoleID

             let station_payload = {
                per_page: this.option_num,
                page_id: 1
            }

            this.$store.dispatch(ACTION_STATION_GET_ALL_STATIONS, station_payload)
            this.$store.dispatch(ACTION_STATION_GET_ALL_EQUIPMENT_TYPES, station_payload)
            let payload = {
                per_page: this.per_page_num,
                page_id: 1,
            }

            this.$store.dispatch(ACTION_CK_PM_CWPMC_GET_ALL_CWPMCS, payload)

            // bulk edit
            if (this.currentUserRoleID == 4) {
                this.showBulkSignButton = true;
            }

        },
        data: function () {
            return {
                feature_img: require("../../../../../../../../assets/images/features/default.png"),
                logo: require("../../../../../../../../assets/images/logo/sbs_transit.png"),
                per_page_num: 20,
                option_num: 99999,
                search: null,
                expandedModel: [true],
                type_of_maintenance: [
                    {
                        'id': 1,
                        'name': 'Monthly - Fill Up Item 1 to 8 only'
                    },
                    {
                        'id': 2,
                        'name': 'Quartery - Fill Up Item 1 to 1 only'
                    },
                    // {
                    //     'id': 3,
                    //     'name': 'Half Yearly - Fill Up Item 1 to 7 only'
                    // },
                    {
                        'id': 4,
                        'name': 'Annually - Fill Up Item 1 to 12 only'
                    },
                ],
                fvs: {
                    headers: [
                        {
                            text: 'No',
                            align: 'left',
                            sortable: false,
                        },
                        { text: 'CheckList No', value: 'checklist_no', sortable: false, },
                        { text: 'Date', value: 'system',sortable: false, },
                        { text: 'Type of Maintenance', value: 'system', sortable: false, },
                        { text: 'View', value: '' ,sortable: false, },
                        { text: 'Edit', value: '' ,sortable: false, },
                        { text: 'Download', value: '' ,sortable: false, },
                        { text: 'Delete', value: '' ,sortable: false, },
                    ],
                },

                user_id: null,

                // Bulk Edit
                selected: [],
                selectedFormID: [],
                checklist_format_id: 18,
                showBulkSignButton: false,

                // LIST DATA TABLE
                openViewDialog: false,
                openAddDialog: false,
                openEditDialog: false,
                openDeleteDialog: false,
                selectedObj: {
                    checklist_no: null,
                    ck_form_id: null,
                    date: null,
                    station_id: null,
                    equipment_id: null,
                    type_of_maintenance: null,

                    task_1: null,
                    task_1_remarks: null,
                    task_2: null,
                    task_2_remarks: null,
                    task_3: null,
                    task_3_remarks: null,
                    task_4: null,
                    task_4_remarks: null,
                    task_5: null,
                    task_5_remarks: null,
                    task_6: null,
                    task_6_remarks: null,
                    task_7: null,
                    task_7_remarks: null,
                    task_8: null,
                    task_8_remarks: null,
                    task_9: null,
                    task_9_remarks: null,
                    task_10: null,
                    task_10_remarks: null,
                    task_11: null,
                    task_11_remarks: null,
                    task_12: null,
                    task_12_remarks: null,
                    
                    additional_remarks: null,
                    maintained_by_name: null,
                    maintained_by_signature: null,
                    signed_by_sbst_name: null,
                    signed_by_sbst_signature: null,
                    status: null,
                    created_by: null
                },

                // new
                newSelectedObj: {
                    checklist_no: null,
                    ck_form_id: null,
                    date: null,
                    station_id: null,
                    equipment_id: null,
                    type_of_maintenance: null,

                    task_1: null,
                    task_1_remarks: null,
                    task_2: null,
                    task_2_remarks: null,
                    task_3: null,
                    task_3_remarks: null,
                    task_4: null,
                    task_4_remarks: null,
                    task_5: null,
                    task_5_remarks: null,
                    task_6: null,
                    task_6_remarks: null,
                    task_7: null,
                    task_7_remarks: null,
                    task_8: null,
                    task_8_remarks: null,
                    task_9: null,
                    task_9_remarks: null,
                    task_10: null,
                    task_10_remarks: null,
                    task_11: null,
                    task_11_remarks: null,
                    task_12: null,
                    task_12_remarks: null,
                                        
                    additional_remarks: null,
                    maintained_by_name: null,
                    maintained_by_signature: null,
                    signed_by_sbst_name: null,
                    signed_by_sbst_signature: null,
                    status: null,
                    created_by: null
                },

                newSubmitDateMenu: false,
                newVisitingDateMenu: false,
                newSign1DateMenu: false,
                newSign1DateMenu: false,
                newSign2DateMenu: false,
                newSign3DateMenu: false,
                newVisitingTimeDialog: false,

                editSubmitDateMenu: false,
                editVisitingDateMenu: false,
                editSign1DateMenu: false,
                editSign1DateMenu: false,
                editSign2DateMenu: false,
                editSign3DateMenu: false,
                editVisitingTimeDialog: false,

                openNewSignPad1: false,
                openNewSignPad2: false,

                openSignPad1: false,
                openSignPad2: false,
            };
        },
        computed: {
            pagination_collections () {
                return this.$store.getters.GETTER_PAGINATION_GET_LISTS
            },
            current_page_id () {
                return this.collection.currentPage
            },
            per_page () {
                return this.collection.perPage
            },
            items() {
                let vm = this
                let result = this.$store.getters.GETTERS_CK_PM_CWPMC_GET_ALL_CWPMCS
                var array = Object.keys(result).map(item => result[item]);

                return array
            },
            allStations() {
                let vm = this
                let result = this.$store.getters.GETTERS_STATION_GET_ALL_STATIONS
                var array = Object.keys(result).map(item => result[item]);

                return array
            },
            allEquipments() {
                let vm = this
                let result = this.$store.getters.GETTERS_STATION_GET_ALL_EQUIPMENT_TYPES
                var array = Object.keys(result).map(item => result[item]);

                return array
            },
            currentAuthUser() {
                let authUser = this.$store.getters.GETTERS_USER_GROUPS_GET_AUTH_USER

                if (this.currentUserRoleID == 1) {
                    this.user_id = authUser.user_group_id
                }
                else {
                    this.user_id = authUser.user_group_id
                }

                return authUser
            },
            computedNewSubmitDate() {
                return this.newSelectedObj.date ?
                    moment(this.newSelectedObj.date).format('YYYY-MM-DD') : ''
            },
            
            computedEditSubmitDate() {
                return this.selectedObj.date ?
                    moment(this.selectedObj.date).format('YYYY-MM-DD') : ''
            },
        },
        watch: {
            pagination_collections: function(value) {
                let defaultCollection = {
                    action: ACTION_CK_PM_CWPMC_GET_ALL_CWPMCS,
                    sort: 'desc',
                    order_by: 'id',
                    per_page: value['meta']['per_page'],
                    current_page: value['meta']['current_page'],
                    last_page: value['meta']['last_page'],
                    total: value['meta']['total'],
                    from: value['meta']['from'],
                    to: value['meta']['to'],
                    data: value['data'],
                    payload: {
                        per_page: this.per_page,
                        page_id: this.current_page_id,
                    }
                }

                this.collection.setState(defaultCollection)
            },
            user_id: function (user_id) {
                this.user_id = user_id

                if (this.currentUserRoleID != 1) {
                    let payload = {
                        per_page: this.per_page,
                        page_id: this.current_page_id,
                        user_id: this.user_id
                    }
                    this.$store.dispatch(ACTION_REPORT_GET_ALL_FIELD_VISIT_SERVICES, payload)
                }
            },

        },
        methods: {
            getFeatureImages: function (icon_url) {
                if (icon_url != null) {
                    return icon_url
                }
                else {
                    return this.feature_img
                }
            },
            selectedNewStationID: function ($event) {
                // console.log(`selected Station ID :${$event}`);
                this.newSelectedObj.station_id = $event
            },
            selectedStationID: function ($event) {
                console.log(`selected Station ID :${$event}`);
                this.selectedObj.station_id = $event
            },
            selectedNewEquipmentID: function ($event) {
                // console.log(`selected Station ID :${$event}`);
                this.newSelectedObj.equipment_id = $event
            },
            selectedEquipmentID: function ($event) {
                // console.log(`selected Station ID :${$event}`);
                this.selectedObj.equipment_id = $event
            },
            selectedNewTypeOfMaintenance: function ($event) {
                // console.log(`selected Station ID :${$event}`);
                this.newSelectedObj.type_of_maintenance = $event
            },

            searchByReportNo: function () {

                let payload = {
                    checklist_no: this.search,
                    per_page: this.per_page_num,
                    page_id: 1,
                    user_id: null
                }
                this.$store.dispatch(ACTION_REPORT_GET_ALL_FIELD_VISIT_SERVICES, payload)
            },
            openViewDialogAction: function (item) {
                this.openViewDialog = true
                item.station_id = parseInt(item.station_id);
                item.equipment_id = parseInt(item.equipment_id);
                this.selectedObj = item
            },
            openAddDialogAction: function () {
                this.openAddDialog = true
                var current_datetime = moment().format("YYYYMMDDHHmmss")
                this.newSelectedObj.checklist_no = `FV${current_datetime}`
                // this.$router.push({ name: 'Create New Fault Call Service', params: { } })
            },
            openEditDialogAction: function (item) {
                this.openEditDialog = true
                item.station_id = parseInt(item.station_id);
                item.equipment_id = parseInt(item.equipment_id);
                this.selectedObj = item
            },
            openDeleteDialogAction: function (item) {
                this.openDeleteDialog = true

                this.selectedObj = item
            },
            
            dataURItoBlob:function (base64Data) {
                var byteString;
                if (base64Data.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(base64Data.split(',')[1]);
                else
                byteString = unescape(base64Data.split(',')[1]);
                var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
                var ia = new Uint8Array(byteString.length);
                for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
                }
                return new Blob([ia], {type:mimeString});
            },
            openNewSign1Action() {
                this.openNewSignPad1 = true
                this.$nextTick(function () {
                    this.$refs.newSignaturePad1.resizeCanvas(this.$refs.newSignaturePad1.$refs.signaturePadCanvas);
                // this.$refs.signaturePad.resizeCanvas() <- WOULD BE EASIER
                });
                    },
            newUndoSign1() {
                this.$refs.newSignaturePad1.undoSignature();
            },
            newSaveSign1() {
                const { isEmpty, data } = this.$refs.newSignaturePad1.saveSignature();
                //console.log(isEmpty);
                //console.log(data);
                this.newSelectedObj.maintained_by_signature = this.dataURItoBlob(data)
                //console.log(this.newSelectedObj.inspectionSignFile);
            },
            openNewSign2Action() {
                this.openNewSignPad2 = true
                this.$nextTick(function () {
                    this.$refs.newSignaturePad2.resizeCanvas(this.$refs.newSignaturePad2.$refs.signaturePadCanvas);
                // this.$refs.signaturePad.resizeCanvas() <- WOULD BE EASIER
                });
                    },
            newUndoSign2() {
                this.$refs.newSignaturePad2.undoSignature();
            },
            newSaveSign2() {
                const { isEmpty, data } = this.$refs.newSignaturePad2.saveSignature();
                //console.log(isEmpty);
                //console.log(data);
                this.newSelectedObj.signed_by_sbst_signature = this.dataURItoBlob(data)
                //console.log(this.newSelectedObj.inspectionSignFile);
            },
            

            openSign1Action() {
                this.openSignPad1 = true
                this.$nextTick(function () {
                    this.$refs.signaturePad1.resizeCanvas(this.$refs.signaturePad1.$refs.signaturePadCanvas);
                // this.$refs.signaturePad.resizeCanvas() <- WOULD BE EASIER
                });
                    },
            undoSign1() {
                this.$refs.signaturePad1.undoSignature();
            },
            saveSign1() {
                const { isEmpty, data } = this.$refs.signaturePad1.saveSignature();
                //console.log(isEmpty);
                console.log(data);
                this.selectedObj.maintained_by_signature = this.dataURItoBlob(data)
                //console.log(this.newSelectedObj.inspectionSignFile);
            },

            openSign2Action() {
                this.openSignPad2 = true
                this.$nextTick(function () {
                    this.$refs.signaturePad2.resizeCanvas(this.$refs.signaturePad2.$refs.signaturePadCanvas);
                // this.$refs.signaturePad.resizeCanvas() <- WOULD BE EASIER
                });
                    },
            undoSign2() {
                this.$refs.signaturePad2.undoSignature();
            },
            saveSign2() {
                const { isEmpty, data } = this.$refs.signaturePad2.saveSignature();
                //console.log(isEmpty);
                console.log(data);
                this.selectedObj.signed_by_sbst_signature = this.dataURItoBlob(data)
                //console.log(this.newSelectedObj.inspectionSignFile);
            },

            addResourceAction: function () {
                const formData = new FormData();

                if (this.newSelectedObj.checklist_no != null) {
                    formData.append('checklist_no', this.newSelectedObj.checklist_no);
                }

                if (this.newSelectedObj.ck_form_id != null) {
                    formData.append('ck_form_id', this.newSelectedObj.ck_form_id);
                }

                if (this.newSelectedObj.date != null) {
                    formData.append('date', this.newSelectedObj.date);
                }

                if (this.newSelectedObj.station_id != null) {
                    formData.append('station_id', this.newSelectedObj.station_id);
                }

                if (this.newSelectedObj.equipment_id != null) {
                    formData.append('equipment_id', this.newSelectedObj.equipment_id);
                }
                
                formData.append('type_of_maintenance', this.newSelectedObj.type_of_maintenance);

                // ======================
                // FORM FIELD HERE:

                if (this.newSelectedObj.task_1 != null) {
                    formData.append('task_1', this.newSelectedObj.task_1);
                }

                if (this.newSelectedObj.task_1_remarks != null) {
                    formData.append('task_1_remarks', this.newSelectedObj.task_1_remarks);
                }

                if (this.newSelectedObj.task_2 != null) {
                    formData.append('task_2', this.newSelectedObj.task_2);
                }

                if (this.newSelectedObj.task_2_remarks != null) {
                    formData.append('task_2_remarks', this.newSelectedObj.task_2_remarks);
                }                

                if (this.newSelectedObj.task_3 != null) {
                    formData.append('task_3', this.newSelectedObj.task_3);
                }

                if (this.newSelectedObj.task_3_remarks != null) {
                    formData.append('task_3_remarks', this.newSelectedObj.task_3_remarks);
                }

                if (this.newSelectedObj.task_4 != null) {
                    formData.append('task_4', this.newSelectedObj.task_4);
                }

                if (this.newSelectedObj.task_4_remarks != null) {
                    formData.append('task_4_remarks', this.newSelectedObj.task_4_remarks);
                }

                if (this.newSelectedObj.task_5 != null) {
                    formData.append('task_5', this.newSelectedObj.task_5);
                }

                if (this.newSelectedObj.task_5_remarks != null) {
                    formData.append('task_5_remarks', this.newSelectedObj.task_5_remarks);
                }

                if (this.newSelectedObj.task_6 != null) {
                    formData.append('task_6', this.newSelectedObj.task_6);
                }

                if (this.newSelectedObj.task_6_remarks != null) {
                    formData.append('task_6_remarks', this.newSelectedObj.task_6_remarks);
                }

                if (this.newSelectedObj.task_7 != null) {
                    formData.append('task_7', this.newSelectedObj.task_7);
                }

                if (this.newSelectedObj.task_7_remarks != null) {
                    formData.append('task_7_remarks', this.newSelectedObj.task_7_remarks);
                }

                if (this.newSelectedObj.task_8 != null) {
                    formData.append('task_8', this.newSelectedObj.task_8);
                }

                if (this.newSelectedObj.task_8_remarks != null) {
                    formData.append('task_8_remarks', this.newSelectedObj.task_8_remarks);
                }

                if (this.newSelectedObj.task_9 != null) {
                    formData.append('task_9', this.newSelectedObj.task_9);
                }

                if (this.newSelectedObj.task_9_remarks != null) {
                    formData.append('task_9_remarks', this.newSelectedObj.task_9_remarks);
                }

                if (this.newSelectedObj.task_10 != null) {
                    formData.append('task_10', this.newSelectedObj.task_10);
                }

                if (this.newSelectedObj.task_10_remarks != null) {
                    formData.append('task_10_remarks', this.newSelectedObj.task_10_remarks);
                }

                if (this.newSelectedObj.task_11 != null) {
                    formData.append('task_11', this.newSelectedObj.task_11);
                }

                if (this.newSelectedObj.task_11_remarks != null) {
                    formData.append('task_11_remarks', this.newSelectedObj.task_11_remarks);
                }

                if (this.newSelectedObj.task_12 != null) {
                    formData.append('task_12', this.newSelectedObj.task_12);
                }

                if (this.newSelectedObj.task_12_remarks != null) {
                    formData.append('task_12_remarks', this.newSelectedObj.task_12_remarks);
                }

                // End of Fields
                // ======================
                
                //  Standard Fields 

                if (this.newSelectedObj.additional_remarks != null) {
                    formData.append('additional_remarks', this.newSelectedObj.additional_remarks);
                }

                if (this.newSelectedObj.status != null) {
                    formData.append('status', this.newSelectedObj.status);
                }

                if (this.newSelectedObj.maintained_by_name != null) {
                    formData.append('maintained_by_name', this.newSelectedObj.maintained_by_name);
                }

                if (this.newSelectedObj.maintained_by_signature != null) {
                    formData.append('maintained_by_signature', this.newSelectedObj.maintained_by_signature, 'sign1.png')
                }

                if (this.newSelectedObj.signed_by_sbst_name != null) {
                    formData.append('signed_by_sbst_name', this.newSelectedObj.signed_by_sbst_name);
                }

                if (this.newSelectedObj.signed_by_sbst_signature != null) {
                    formData.append('signed_by_sbst_signature', this.newSelectedObj.signed_by_sbst_signature, 'sign2.png')
                }

                if (this.newSelectedObj.created_by != null) {
                    formData.append('created_by', this.newSelectedObj.created_by)
                }
                
                console.log(this.newSelectedObj);
              
                this.$store.dispatch(ACTION_CK_PM_CWPMC_ADD_NEW_CWPMC, formData)

                this.newSelectedObj = {
                    checklist_no: null,
                    ck_form_id: null,
                    date: null,
                    station_id: null,
                    equipment_id: null,
                    type_of_maintenance: null,

                    task_1: null,
                    task_1_remarks: null,
                    task_2: null,
                    task_2_remarks: null,
                    task_3: null,
                    task_3_remarks: null,
                    task_4: null,
                    task_4_remarks: null,
                    task_5: null,
                    task_5_remarks: null,
                    task_6: null,
                    task_6_remarks: null,
                    task_7: null,
                    task_7_remarks: null,
                    task_8: null,
                    task_8_remarks: null,
                    task_9: null,
                    task_9_remarks: null,
                    task_10: null,
                    task_10_remarks: null,
                    task_11: null,
                    task_11_remarks: null,
                    task_12: null,
                    task_12_remarks: null,
                                        
                    additional_remarks: null,
                    maintained_by_name: null,
                    maintained_by_signature: null,
                    signed_by_sbst_name: null,
                    signed_by_sbst_signature: null,
                    status: null,
                    created_by: null
                };

                this.openAddDialog = false
            },
            editResourceAction: function () {
                const formData = new FormData();
                formData.append('cwpmc_id', this.selectedObj.id);

                if (this.selectedObj.checklist_no != null) {
                    formData.append('checklist_no', this.selectedObj.checklist_no);
                }

                if (this.selectedObj.ck_form_id != null) {
                    formData.append('ck_form_id', this.selectedObj.ck_form_id);
                }

                if (this.selectedObj.date != null) {
                    formData.append('date', this.selectedObj.date);
                }

                if (this.selectedObj.station_id != null) {
                    formData.append('station_id', this.selectedObj.station_id);
                }

                if (this.selectedObj.equipment_id != null) {
                    formData.append('equipment_id', this.selectedObj.equipment_id);
                }
                
                if (this.selectedObj.type_of_maintenance != null) {
                    formData.append('type_of_maintenance', this.selectedObj.type_of_maintenance);
                }

                // ======================
                // FORM FIELD HERE:

                if (this.selectedObj.task_1 != null) {
                    formData.append('task_1', this.selectedObj.task_1);
                }

                if (this.selectedObj.task_1_remarks != null) {
                    formData.append('task_1_remarks', this.selectedObj.task_1_remarks);
                }

                if (this.selectedObj.task_2 != null) {
                    formData.append('task_2', this.selectedObj.task_2);
                }

                if (this.selectedObj.task_2_remarks != null) {
                    formData.append('task_2_remarks', this.selectedObj.task_2_remarks);
                }                

                if (this.selectedObj.task_3 != null) {
                    formData.append('task_3', this.selectedObj.task_3);
                }

                if (this.selectedObj.task_3_remarks != null) {
                    formData.append('task_3_remarks', this.selectedObj.task_3_remarks);
                }

                if (this.selectedObj.task_4 != null) {
                    formData.append('task_4', this.selectedObj.task_4);
                }

                if (this.selectedObj.task_4_remarks != null) {
                    formData.append('task_4_remarks', this.selectedObj.task_4_remarks);
                }

                if (this.selectedObj.task_5 != null) {
                    formData.append('task_5', this.selectedObj.task_5);
                }

                if (this.selectedObj.task_5_remarks != null) {
                    formData.append('task_5_remarks', this.selectedObj.task_5_remarks);
                }

                if (this.selectedObj.task_6 != null) {
                    formData.append('task_6', this.selectedObj.task_6);
                }

                if (this.selectedObj.task_6_remarks != null) {
                    formData.append('task_6_remarks', this.selectedObj.task_6_remarks);
                }

                if (this.selectedObj.task_7 != null) {
                    formData.append('task_7', this.selectedObj.task_7);
                }

                if (this.selectedObj.task_7_remarks != null) {
                    formData.append('task_7_remarks', this.selectedObj.task_7_remarks);
                }

                if (this.selectedObj.task_8 != null) {
                    formData.append('task_8', this.selectedObj.task_8);
                }

                if (this.selectedObj.task_8_remarks != null) {
                    formData.append('task_8_remarks', this.selectedObj.task_8_remarks);
                }

                if (this.selectedObj.task_9 != null) {
                    formData.append('task_9', this.selectedObj.task_9);
                }

                if (this.selectedObj.task_9_remarks != null) {
                    formData.append('task_9_remarks', this.selectedObj.task_9_remarks);
                }

                if (this.selectedObj.task_10 != null) {
                    formData.append('task_10', this.selectedObj.task_10);
                }

                if (this.selectedObj.task_10_remarks != null) {
                    formData.append('task_10_remarks', this.selectedObj.task_10_remarks);
                }

                if (this.selectedObj.task_11 != null) {
                    formData.append('task_11', this.selectedObj.task_11);
                }

                if (this.selectedObj.task_11_remarks != null) {
                    formData.append('task_11_remarks', this.selectedObj.task_11_remarks);
                }

                if (this.selectedObj.task_12 != null) {
                    formData.append('task_12', this.selectedObj.task_12);
                }

                if (this.selectedObj.task_12_remarks != null) {
                    formData.append('task_12_remarks', this.selectedObj.task_12_remarks);
                }

                // End of Fields
                // ======================

                if (this.selectedObj.additional_remarks != null) {
                    formData.append('additional_remarks', this.selectedObj.additional_remarks);
                }

                if (this.selectedObj.status != null) {
                    formData.append('status', this.selectedObj.status);
                }

                if (this.selectedObj.maintained_by_name != null) {
                    formData.append('maintained_by_name', this.selectedObj.maintained_by_name);
                }

                if (this.selectedObj.maintained_by_signature != null) {
                    formData.append('maintained_by_signature', this.selectedObj.maintained_by_signature, 'sign1.png')
                }

                if (this.selectedObj.signed_by_sbst_name != null) {
                    formData.append('signed_by_sbst_name', this.selectedObj.signed_by_sbst_name);
                }

                if (this.selectedObj.signed_by_sbst_signature != null) {
                    formData.append('signed_by_sbst_signature', this.selectedObj.signed_by_sbst_signature, 'sign2.png')
                }

                if (this.selectedObj.created_by != null) {
                    formData.append('created_by', this.selectedObj.created_by)
                }
                
                this.$store.dispatch(ACTION_CK_PM_CWPMC_UPDATE_CWPMC, formData)

                this.openEditDialog = false
            },
            deleteResourceAction: function (id) {
                let payload = {
                    cwpmc_id: id
                }
                this.$store.dispatch(ACTION_CK_PM_CWPMC_DELETE_CWPMC, payload)
                this.openDeleteDialog = false
            },
            // bulk edit
            toggleAll () {
                if (this.selected.length) {
                    this.selected = []
                }
                else {
                    this.selected = this.items.slice()
                }
            },
            navigateToBulkDialogPage: function () {
                let vm = this
                vm.selectedFormID = []
                vm.selected.forEach(function (singleForm) {
                    vm.selectedFormID.push(singleForm.id);
                });

                vm.$router.push({ 
                    name: 'SBST Bulk Sign CheckList Forms', 
                    query: { 
                        format_id: vm.checklist_format_id,
                        selected_forms: vm.selectedFormID
                    } 
                });
            },
            viewDownloadReport: function (item) {
                this.openViewDownloadDialog = true;
                this.selectedObj = item;
            },
            downloadReportNow: function (item) {
                this.selectedObj = item;
                this.$refs.html2Pdf.generatePdf();
            },
        },
        components: {
            appVuePagination: VuePagination,
            appVueHtml2pdf: VueHtml2pdf,
        }
    }
</script>

<style lang="css" scoped>
    .signature_box {
        border-style: solid;
    }

    .subTitle {
        margin-top: 10px;
        margin-left: -15px;
    }

    table.myFormTable {
        font-family: arial, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    table.myFormTable > tbody > tr > td, table.myFormTable > thead > tr >th {
        border: 1px solid #dddddd;
        text-align: left;
        padding: 8px;
    }

    table.myFormTable > tr:nth-child(even) {
        background-color: #dddddd;
    }

    /* pdf  */
    .border-container {
        border: 2px solid #000;
        margin: 2%;
        height: 100%;
        width: 95%;
    }

    .pdf-header {
        width: 100%;
        margin: auto;
        text-align: center;
        justify-content: center;
        color: #000;
    }

    .textBlack {
        color: #000000;
    }

    table.pdf {
        border-collapse: collapse;
        width: 100%
    }

    table.pdf, table.pdf th, table.pdf td {
        border: 1px solid black;
        padding: 5px;
    }

    .tableTextCenter{
        margin: auto;
        text-align: center;
        justify-content: center;
    }
</style>